
export const EMPTY_KITS = "No Kits to load!!!Kindly create new Kit";
export const EMPTY_TESTS = "No Tests to load!!!Kindly create new Test";
export const EMPTY_HISTORY = "No download history is present";